import React from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import PropTypes from "prop-types";
import SvgIcon from "./SvgIcon";
import ToolTip from "./tooltip-portal";

export const PasteMealComponent = ({
  meal,
  day,
  query,
  planMode,
  week,
  classNames,
  withFullInfo = false,
  showPasteMeal,
  hasFoods = false,
}) => {
  const hasClipboardData =
    typeof window !== "undefined" &&
    (() => {
      try {
        const m = localStorage.getItem("mealsToCopy");
        const meta = localStorage.getItem("mealCopyMetadata");
        return !!(m && meta);
      } catch {
        return false;
      }
    })();

  /**
   * Paste meals: action reads foods/metadata from localStorage at paste time (same as exercises)
   */
  const handlePasteMeal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof window === "undefined") return;

    const { mealPlan, athlete } = query;
    const { date, dayType, optionId } = day;
    const { type: mealType } = meal;
    const currentPlanMode = planMode || "detailed";

    let body = {
      targetPlanMode: currentPlanMode,
      targetMealType: mealType,
    };

    if (currentPlanMode === "simplified" && dayType && optionId) {
      body = {
        ...body,
        planMode: "simplified",
        dayType: dayType,
        optionId: optionId,
      };
    } else {
      body = { ...body, date: date };
    }

    const pasteUrl =
      currentPlanMode === "detailed" && week != null && week !== ""
        ? `/actions/meal-planner/paste-meal?mealPlanId=${mealPlan}&proxyAthlete=${athlete}&week=${week}`
        : `/actions/meal-planner/paste-meal?mealPlanId=${mealPlan}&proxyAthlete=${athlete}`;
    submit(pasteUrl, {
      method: "POST",
      body,
    });
  };

  const { t } = useTranslation("coaching-portal");

  if (!hasClipboardData) return null;

  if (withFullInfo) {
    return (
      <a
        className={classNames}
        href="#"
        onClick={handlePasteMeal}
        aria-disabled={
          showPasteMeal !== undefined ? !showPasteMeal : undefined
        }
      >
        <SvgIcon src="/img/new-icons/vuesax-linear-paste-square.svg" />
        <span>{t("pasteMeal.pasteMeal")}</span>
      </a>
    );
  }

  if (hasFoods) {
    return (
      <ToolTip body={t("pasteMeal.pasteMeal")}>
        <a
          href="#"
          onClick={handlePasteMeal}
          data-button-type="secondary"
          role="button"
        >
          <SvgIcon src="/img/new-icons/paste.svg" />
        </a>
      </ToolTip>
    );
  }

  return (
    <button
      id="button-local-paste-meal"
      className={classNames}
      onClick={handlePasteMeal}
    >
      <SvgIcon src="/img/new-icons/paste.svg" />
    </button>
  );
};

PasteMealComponent.propTypes = {
  meal: PropTypes.object,
  day: PropTypes.object,
  query: PropTypes.object,
  planMode: PropTypes.string,
  week: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  classNames: PropTypes.string,
  withFullInfo: PropTypes.bool,
  showPasteMeal: PropTypes.bool,
  hasFoods: PropTypes.bool,
};
